import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { ToastProvider, TooltipProvider } from "@/components";
import { BalanceCaptureProvider } from "./BalanceCaptureProvider";
import { ThemeProvider } from "./theme/ThemeProvider";

/** App-wide providers: data cache, theme, tooltip timing, toasts and the balance as a weight source. */
export function AppProviders({ queryClient, children }: { queryClient: QueryClient; children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider>
          <ToastProvider>
            <BalanceCaptureProvider>{children}</BalanceCaptureProvider>
          </ToastProvider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
